
  import { mapState, mapGetters } from 'vuex'
  import baseLogic from '~/mixins/base-logic'
  import cms from '~/mixins/common/cms'
  import Meta from '~/mixins/meta'
  import errorCodeStrings from '~/mixins/common/error-code-strings'
  import ServerSide from '~/mixins/serverSide'
  import bannerRedirect from '~/mixins/common/banner-redirect'
  export default {
    name: 'Theme4Layout',
    mixins: [baseLogic, ServerSide, bannerRedirect, cms, Meta, errorCodeStrings],
    data() {
      return {
        isMobileScreen: false,
        loginModal: false,
        registerModal: false,
        displayWithdrawalSocket: false,
        withdrawalStatus: true
      }
    },
    computed: {
      ...mapGetters({
        faviconIcon: 'cms/faviconIcon',
        languages: 'themes/settings/language',
        banks: 'banks/banks'
      }),
      ...mapState({
        menubars: state => state.cms.menus.menus,
        player: state => state.player.player,
        isLogin: state => state.settings.isLogin,
        showHoldBalance: state => state.sockets.showHoldBalance,
        displayGetBonusDetail: state => state.sockets.displayGetBonusDetail,
        displayGetBonusModalState: state => state.sockets.displayGetBonusModal,
        displayRegisterModal: state => state.themes.settings.displayRegisterModal,
        floatingIcons: state => state.cms.floatingIcons,
        errorStrings: state => state.themes['language-string'].errorStrings,
        hiddenOverflowLanguageChange: state => state.settings.hiddenOverflowLanguageChange
      }),
      displayGetBonusModal: {
        get() {
          return this.displayGetBonusModalState
        },
        set(value) {
          this.$store.commit('sockets/setDisplayGetBonusModal', value)
        }
      },
      navbarComponentName() {
        return this.isMobileScreen ? 'Theme4MobileNavBar' : 'Theme4DesktopNavBar'
      }
    },
    watch: {
      displayRegisterModal(value) {
        this.registerModal = value
      },
      hiddenOverflowLanguageChange(value) {
        // html , body  Language Change Overlay
        if (value) {
          document.documentElement.style.setProperty('overflow', 'hidden')
          document.body.style.setProperty('overflow', 'hidden')
        } else {
          // document.documentElement.style.setProperty('overflow', 'auto')
          // document.body.style.setProperty('overflow', 'auto')
          // remove overflow hidden to prevent issue with some browser
          document.documentElement.style.removeProperty('overflow')
          document.body.style.removeProperty('overflow')
        }
      }
    },
    created() {
      this.$vuetify.theme.dark = true
    },
    async mounted() {
      this.$store?.dispatch('app/checkIsApp')
      // Fetch error code
      await this.getErrorCodeStrings()
      try {
        this.$cookie.set('previous_url', document.referrer)
      } catch (error) {}
      this.showBanner()
      this.$store.dispatch('player/getPlayerInviteAndEarnDomain') // Get invite and earn domain link (refer-friend page)
      this.getFaviconIcon()

      // To set mission basic setting
      // Since the /activities page onMounted also fire this API
      // By handling in the layout layer is to prevent duplicate API fires
      if (this.$route.path !== '/activities')
        this.$store.dispatch('activities/mission-reward/getMissionSettings', {
          currency: this.$store.state.settings.defaultCurrency
        })
      // To fetch VIP Privilege info
      this.$store.dispatch('activities/vip-system/getVipTiers', {
        currency: this.$store.state.settings.defaultCurrency
      })
      this.$store.dispatch('activities/vip-system/getVipSettings', {
        currency: this.$store.state.settings.defaultCurrency
      })

      if (this.$cookie.get('token')) {
        // Get all missions badges (Badges number)
        this.$store.dispatch('activities/mission-reward/getMissionBadge')
        // Get all notifications
        this.$store.dispatch('activities/notification/getNotifications')

        // Get all notifications
        this.$store.dispatch('activities/notification/getNotifications')
        // Get message notification badges
        this.$store.dispatch('themes/player/getMessageNotificationBadges')
      }

      if (this.$cookie?.get('is_change_language')) {
        this.$store.commit('settings/changeLanguageLoading', true)
      }
      // Local settings
      const locale = this.handleCookie('wl_locale')
      if (locale) {
        this.$recaptcha.language = locale
      }

      if (this.menubars.length <= 0) this.$store.dispatch('cms/menus/getMenubars')
      // Call this store action only when the user is not on the home page and mobile device
      if (this.$route.path !== '/' && !this.isMobileOnly())
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 1,
          component_code: 'DesktopBackground'
        })
      // Call this store action only when the user is not on the home page but on mobile device
      if (this.$route.path !== '/' && this.isMobileOnly())
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'MobileBackground'
        })

      await this.setDefaultLanguages()

      // Fetch visit API
      this.$store.dispatch('themes/settings/fetchVisitWebsite')
      this.$store.dispatch('themes/settings/markAssociatedPlayer')

      this.onResize()
      await this.initializeSettings()

      // Check playerMessage
      this.$store.subscribeAction((mutation, state) => {
        if (mutation.type === 'sockets/playerMessage') {
          this.$store.dispatch('themes/player/getMessageNotificationBadges')
          if (this.$route.path === '/player/messages') {
            this.$store.dispatch('themes/player/getMessage')
          }
        }
      })
    },
    methods: {
      onResize() {
        if (process.browser) {
          const MOBILE_SCREEN_WIDTH = 1300
          const width = process.client ? window.innerWidth : 0
          this.isMobileScreen = width < MOBILE_SCREEN_WIDTH
          this.$store.commit('themes/settings/setIsMobile', this.isMobileScreen)
          return null
        }
        this.isMobileScreen = false
        this.$store.commit('themes/settings/setIsMobile', this.isMobileScreen)
      },
      onShowLoginModal() {
        this.loginModal = true
      },
      onShowRegisterModal() {
        this.registerModal = true
      },
      closeHoldBalanceDialog() {
        this.$store.commit('sockets/setShowHoldBalance', false)
      },
      async initializeSettings() {
        await this.$store.dispatch('settings/supportCountryAndLanguage')
        this.$store.dispatch('cms/floatingIcons')
        if (this.$cookie.get('token')) {
          this.initSocketTheme()
          await this.$store.dispatch('themes/player-bank/getBankPlayerAccount')
          await this.$store.dispatch('banks/accounts')
        }
        if (!this.languages.length) {
          await this.setDefaultLanguages()
        }
        if (this.$cookie.get('currency')) {
          await this.$store.dispatch('settings/operationSetting', this.$cookie.get('currency'))
        }
        await this.$store.dispatch('themes/settings/getExchangeRate')
        this.$store.commit('settings/changeLanguageLoading', false)
        this.$cookie.remove('is_change_language')
      }
    }
  }
